import { Object3D } from 'three';
import { setRaycastEnabled } from '@modules/three/common/raycastControl';

/**
 * Toggles visibility and raycast participation for an Object3D (and all its descendants).
 * - Sets `object.visible = visibility`.
 * - Enables/disables raycast using RaycastControl helpers (falls back to userData flags).
 * - Applies recursively to all children.
 */
export function toggleVisibility(target: Object3D | Object3D[], visibility: boolean): void {
  const list: Object3D[] = Array.isArray(target) ? target : [target];
  for (const root of list) {
    root.traverse((obj) => {
      obj.visible = visibility;
      setRaycastEnabled(obj, visibility);
    });
  }
}

export default toggleVisibility;

